import { CommonService } from "../../../../../services/CommonService";
import CompetencesAndSkills from "../../components/CompetencesAndSkills";
import { FieldNames } from "../../FieldNames";
import { order } from "../SmartSearchParammeter";
export default async function TechnologiesSearchConfig(key) {
  let technologies = await CommonService.getTechSkills();
  return {
    description: "Technologies",
    id: "skills",
    initial: [],
    type: order.first,
    handleValues: (searchObject) => {
      searchObject.skills = searchObject.skills.map((t) => t.id);
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <CompetencesAndSkills
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    operation: ["Must"],
    list: technologies.map((t) => t.description.replace(/,/g, "#")),
    examples: [
      `Natural Language: "I want a developer with experience in Angular\nStructured Query: " ${key} Must Angular"`
    ],
    handler: function (searchObj, value) {
      let selected = technologies.filter((t) =>
        value.includes(t.description.replace(/,/g, "#"))
      );
      searchObj[FieldNames.skills] = selected;
    }
  };
}
